import React, { useState } from 'react'
import { XMarkIcon, EllipsisVerticalIcon } from "@heroicons/react/24/outline";

function HeaderWithAction({ title, handleClose, isEditing, handleEdit, showButton }) {
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  return (
    <div
      className="flex justify-between p-4 text-white sticky top-0"
      style={{ backgroundColor: "#6366f1" }}
    >
      <h1 className="mx-auto sm:px-6 sm:mx-0 md:px-8 sm:text-lg font-medium mb-2 uppercase">
        {title}
      </h1>

      <div className="flex gap-2">
        {/* Close Icon */}
        <XMarkIcon onClick={handleClose} className="h-6 w-6 cursor-pointer" />

        {/* Edit Options (Only shown when isEditing and showButton are true) */}
        {isEditing && showButton && (
          <div className="relative">
            <button
              type="button"
              className="inline-flex items-center gap-x-1 text-sm font-semibold text-gray-900"
              aria-expanded={isOpenEdit}
            >
              <EllipsisVerticalIcon
                onClick={() => setIsOpenEdit(!isOpenEdit)}
                className="h-6 w-6 cursor-pointer text-white"
              />
            </button>

            {isOpenEdit && (
              <div className="absolute left-1/2 z-10 mt-5 flex w-screen max-w-min -translate-x-1/2 px-4">
                <div className="w-56 shrink rounded-xl bg-white p-4 text-sm font-semibold text-gray-900 ring-1 shadow-lg ring-gray-900/5">
                  <a
                    href="#"
                    className="block p-2 hover:text-indigo-600"
                    onClick={() => {
                      handleEdit();
                      setIsOpenEdit(false);
                    }}
                  >
                    Edit
                  </a>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderWithAction